/**
 * 修改属性值-只修改之前存在的值
 * @param {*} target 修改的目标
 * @param {*} value 修改的内容
 */
export function modifyData(target, value) {
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(target, key)) {
      // target[key] = value[key];
      // 需要的话，深层逐个赋值
      if (target[key] && typeof target[key] === 'object') {
        modifyData(target[key], value[key]);
      } else {
        target[key] = value[key];
      }
    }
  } 
}

/**
 * 严格获取数字（或数字字符串）的小数点位数
 * @param {number|string} num - 要检查的数字
 * @returns {number} 小数点后的位数
 */
export function getDecimalPlaces(num) {
  if (typeof num !== 'number' && typeof num !== 'string') {
    console.log('参数必须是数字或数字字符串');
    return 0;
  }
  let str = String(num).trim();
  if (!/^-?\d*\.?\d+(?:[eE][+-]?\d+)?$/.test(str)) {
    return 0;
  }
  const sciMatch = str.match(/^([+-]?\d+\.?\d*)[eE]([+-]?\d+)$/);
  if (sciMatch) {
    const coeff = sciMatch[1];
    const exponent = parseInt(sciMatch[2], 10);
    const coeffParts = coeff.split('.');
    let coeffDecimals = 0;
    if (coeffParts.length === 2) {
      coeffDecimals = coeffParts[1].length;
    }
    if (exponent >= 0) {
      return Math.max(0, coeffDecimals - exponent);
    } else {
      return coeffDecimals + (-exponent);
    }
  }
  const parts = str.split('.');
  if (parts.length === 2) {
    return parts[1].length;
  }
  return 0;
}